import { Component, Inject, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BlankValueComponent, CustomCellComponent, MODULE_IMPORTS } from '@vendasta/galaxy/table';
import { GalaxyPipesModule } from '@vendasta/galaxy/pipes';
import { TranslateModule } from '@ngx-translate/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CrmMultilocationInjectionToken, CrmMultiLocationDependencies } from '../../../tokens-and-interfaces';
import { take } from 'rxjs/operators';
import { AccountGroupService, ProjectionFilter } from '@galaxy/account-group';

interface AccountGroupResponse {
  accountGroupId: string;
  napData: {
    companyName: string;
    address: string;
  };
}

@Component({
  selector: 'crm-location-cell',
  styleUrls: ['../shared.scss', './location.component.scss'],
  templateUrl: './location.component.html',
  imports: [
    CommonModule,
    BlankValueComponent,
    GalaxyPipesModule,
    TranslateModule,
    MatIconModule,
    MatButtonModule,
    BlankValueComponent,
    MODULE_IMPORTS,
  ],
})
export class LocationCellComponent extends CustomCellComponent implements OnInit {
  accountGroupInfo: AccountGroupResponse | null = null;
  isMultiLocation = false;
  private namespace: string | null = null;

  constructor(
    @Inject(CrmMultilocationInjectionToken) private multiLocationConfig: CrmMultiLocationDependencies,
    private accountGroupService: AccountGroupService,
  ) {
    super();
  }

  @Input()
  override set value(cellData: { namespace: string }) {
    if (!cellData?.namespace) {
      return;
    }
    this.namespace = cellData.namespace;
    if (this.isMultiLocation) {
      this.loadAccountGroupInfo();
    }
  }

  ngOnInit(): void {
    this.multiLocationConfig.multiLocationContext$?.pipe(take(1)).subscribe((context) => {
      this.isMultiLocation = !!context?.groupId;
      if (this.isMultiLocation && this.namespace) {
        this.loadAccountGroupInfo();
      }
    });
  }

  private loadAccountGroupInfo(): void {
    if (!this.namespace) {
      return;
    }

    this.accountGroupService
      .get(
        this.namespace,
        new ProjectionFilter({
          napData: true,
          accountGroupExternalIdentifiers: true,
          associations: true,
        }),
      )
      .pipe(take(1))
      .subscribe((accountGroup) => {
        this.accountGroupInfo = {
          accountGroupId: accountGroup.accountGroupId,
          napData: {
            companyName: accountGroup.napData?.companyName || '',
            address: accountGroup.napData?.address || '',
          },
        };
      });
  }
}
